var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9762 6.00719H23.3137V3.02344L2.5 6.23594V34.3947L23.3137 37.9797V33.5572H35.9762C36.3599 33.5773 36.7359 33.4443 37.0216 33.1874C37.3073 32.9306 37.4793 32.5708 37.5 32.1872V7.37594C37.479 6.99253 37.3068 6.6331 37.0211 6.3765C36.7355 6.1199 36.3597 5.98708 35.9762 6.00719ZM36.1763 32.4147H23.2713L23.25 30.0534H26.3587V27.3034H23.2262L23.2113 25.6784H26.3587V22.9284H23.1875L23.1725 21.3034H26.3587V18.5534H23.1625V16.9284H26.3587V14.1784H23.1625V12.5534H26.3587V9.80344H23.1625V7.30344H36.1763V32.4147Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1094 9.79688H33.5131V12.5469H28.1094V9.79688ZM28.1094 14.1731H33.5131V16.9231H28.1094V14.1731ZM28.1094 18.5494H33.5131V21.2994H28.1094V18.5494ZM28.1094 22.9256H33.5131V25.6756H28.1094V22.9256ZM28.1094 27.3019H33.5131V30.0519H28.1094V27.3019Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93313 13.8425L10.6156 13.6888L12.3019 18.325L14.2944 13.4975L16.9769 13.3438L13.7194 19.9262L16.9769 26.525L14.1406 26.3337L12.2256 21.3038L10.3094 26.1425L7.70312 25.9125L10.7306 20.0838L7.93313 13.8425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.f0f58d2204a2734a95dd0804cd9f6fdb.svg";
export { ForwardRef as ReactComponent };